import TransitionsModal, { ModalProps as IModalProps } from "./Modal";
export default TransitionsModal;
export type ModalProps = IModalProps;
